import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import Iconify from '../../../../components/Iconify';
import { DebounceInput } from 'react-debounce-input';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const EventDataDialog = props => {
  const { open, setOpen, eventNode } = props;
  const { updateNodeF, setRecalculateHousePositions } = useAccomodationDiagram();
  const [prefix, setPrefix] = React.useState(eventNode.data.prefix || '');

  const onSubmit = () => {
    const node = eventNode;
    node.data = {
      ...node.data,
      prefix
    };
    updateNodeF(node);
    setRecalculateHousePositions([node.data.houseId]);

    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle id="add-new-house-dialog">Dane imprezy {eventNode.data.eventName}</DialogTitle>
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Prefix</Typography>
          <DebounceInput
            sx={{ flex: '1 1 80%' }}
            type="text"
            placeholder="prefix"
            value={prefix}
            onChange={e => setPrefix(e.target.value)}
            debounceTimeout={100}
            element={SmallFormTextField}
            autoFocus
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
